var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.14,11.39l0,1.94c-0.74,0-1.65-0.03-2.39,0.06c-0.55,0.06-1.1,0.16-1.58,0.45 c-0.45,0.29-0.84,0.78-0.87,1.33l-1.16,0c0-1.91-0.03-3.78-0.13-5.66c0.42-0.03,0.91-0.06,1.29,0.16 c0.13,0.1,0.26,0.26,0.39,0.39C2.81,11.23,4.56,11.75,6.14,11.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 5.63,
    className: "st0",
    width: 33.55,
    height: 8.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.42,14.42H15.87c-0.32,0-0.58-0.26-0.58-0.58V5.63c0-0.32,0.26-0.58,0.58-0.58h33.55 c0.32,0,0.58,0.26,0.58,0.58v8.22C50,14.16,49.74,14.42,49.42,14.42z M16.45,13.27h32.39V6.21H16.45V13.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 5.63,
    className: "st1",
    width: 31.37,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.24,11.7H15.87c-0.32,0-0.58-0.26-0.58-0.58v-5.5c0-0.32,0.26-0.58,0.58-0.58h31.37 c0.32,0,0.58,0.26,0.58,0.58v5.5C47.81,11.45,47.56,11.7,47.24,11.7z M16.45,10.55h30.21V6.21H16.45V10.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 5.63,
    className: "st0",
    width: 31.37,
    height: 2.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.24,8.24H15.87c-0.32,0-0.58-0.26-0.58-0.58V5.63c0-0.32,0.26-0.58,0.58-0.58h31.37 c0.32,0,0.58,0.26,0.58,0.58v2.03C47.81,7.98,47.56,8.24,47.24,8.24z M16.45,7.08h30.21V6.21H16.45V7.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.96,32.46c-4.33-0.26-5.07-6.34-5.4-10.02c-0.71-4.4-3.1-6.5-3.65-6.3C6.68,16.56,6,26.48,5.16,30.23 c-0.45,2.04-0.29,3.49-0.94,3.88c-4.46-4.01,3.23-15.29-1.88-15.29c3.52-2.2,3.78-9.66-0.03-10.8c3.04-1.07,4.27-2.68,5.27-3.3 l2.75,0c0.71,0.36,1.65,0.91,2.94,1.78l0.06,6.27c-0.26,0.55-2.68,2.1-2.68,2.1s2.68,1.58,3.65,2.36 c-0.58,0.97-1.29,0.74-1.16,1.91c0.23,2.17,1.71,3.59,1.71,8.82C14.86,30.1,15.79,31.04,16.96,32.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.31,
    y: 5,
    className: "st0",
    width: 5.13,
    height: 9.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.44,15.05h-5.13c-0.32,0-0.58-0.26-0.58-0.58l0-9.46c0-0.15,0.06-0.3,0.17-0.41 C13,4.49,13.15,4.43,13.3,4.43h5.13c0.32,0,0.58,0.26,0.58,0.58v9.46C19.01,14.79,18.76,15.05,18.44,15.05z M13.89,13.89h3.97 v-8.3h-3.97L13.89,13.89z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.14,
    y: 37.39,
    className: "st0",
    width: 31.04,
    height: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.19,45.57H6.14c-0.32,0-0.58-0.26-0.58-0.58v-7.6c0-0.32,0.26-0.58,0.58-0.58h31.04 c0.32,0,0.58,0.26,0.58,0.58V45C37.76,45.32,37.51,45.57,37.19,45.57z M6.72,44.42h29.89v-6.44H6.72V44.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.18,
    y: 37.39,
    className: "st0",
    width: 2.83,
    height: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.01,45.57h-2.83c-0.32,0-0.58-0.26-0.58-0.58v-7.6c0-0.32,0.26-0.58,0.58-0.58h2.83 c0.32,0,0.58,0.26,0.58,0.58V45C40.59,45.32,40.33,45.57,40.01,45.57z M37.76,44.42h1.67v-6.44h-1.67V44.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.01,38.19 40.01,44.2 49.42,41.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.01,44.78c-0.12,0-0.24-0.04-0.34-0.11c-0.15-0.11-0.24-0.28-0.24-0.47v-6.02c0-0.19,0.09-0.36,0.24-0.47 c0.15-0.11,0.34-0.14,0.52-0.08l9.41,3.02c0.24,0.08,0.4,0.3,0.4,0.55c0,0.25-0.16,0.48-0.4,0.55l-9.41,3 C40.13,44.77,40.07,44.78,40.01,44.78z M40.59,38.98v4.43l6.93-2.21L40.59,38.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.77,
    y: 37.41,
    className: "st1",
    width: 13.8,
    height: 7.59
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalking);
export default __webpack_public_path__ + "static/media/chalking.6314ca6610d7d1a1cf50f2ca609e3fdb.svg";
export { ForwardRef as ReactComponent };